<template>
    <div class="bg-img">
        <div class="bg-img event-details" @click="closeOptions($event)">
            <div class="container">
                <div class="header"><span>ADD EVENT DETAILS</span></div>
                <div class="header2"><span>Attract artist to perform</span></div>
                <div class="input-class">
                    <label class="input-value">
                        <span>SOUND:</span>
                        <div class="tags" v-for="(item, index) in limitedValue" :key="index">
                            {{ item }}
                            <span class="tag-remove" @click="removeTag(index)">&#215;</span>
                        </div>
                    </label>
                    <input
                        ref="tagsInput"
                        class="tags-input"
                        type="text"
                        placeholder="Add more tags here"
                        maxlength="18"
                        v-model="selectedOption"
                        @keyup.enter="updateValue"
                        :disabled="value.length >= 5"
                        @focus="showOptions"
                        @input="updateTagValue($event.target.value)"
                    />
                    <div v-if="isVisible" class="tags-list" id="customOptions">
                        <p
                            v-for="(tag, index) in tags"
                            :key="index"
                            @click="selectedTagValue(tag)"
                        >
                            {{ tag }}
                        </p>
                    </div>
                </div>
                <BudgetInfo
                    @update:minBudget="handleMinBudget"
                    @update:maxBudget="handleMaxBudget"
                    @update:averageBudget="handleAverageBudget"
                />
                <button @click="goToNextStep" class="next-step-budget-btn">CONTINUE</button>
                <p @click="goToPrevPage" class="back-step-budget-btn">Back</p>
            </div>
        </div>
    </div>
</template>
<script>
    import BudgetInfo from './BudgetInfo.vue'

    export default {
        name: 'SoundBudget',
        props: {
            defaultVals: {
                type: Object
            },
            average: {
                type: Number
            }
        },
        components: {
            BudgetInfo
        },
        data() {
            return {
                selectedOption: '',
                item: '',
                isVisible: false,
                inputValue: '',
                maxBudget: null,
                minBudget: null,
                averageBudget: null,
                defaultMax: 5000,
                defaultMin: 50,
                value: [],
                filterChartData: null,
                chartInstance: null,
                selectedDataHeight: '',
                tags: ['Dancing', 'Rock', 'Greate for dinning'],
                venueSoundBidgetData: {}
            }
        },
        methods: {
            removeTag(index) {
                this.value.splice(index, 1)
            },
            updateValue() {
                if (this.inputValue.trim() !== '') {
                    this.value.push(this.inputValue)
                    this.inputValue = ''
                    this.selectedOption = ''
                    this.isVisible = true
                }
            },
            showOptions() {
                this.isVisible = !this.isVisible
            },
            updateTagValue(value) {
                this.item = value
                this.selectedOption = value
                this.inputValue = value
                this.isVisible = true
                this.$nextTick(() => {
                    this.$refs.tagsInput.focus()
                })
            },
            selectedTagValue(tag) {
                this.selectedOption = tag
                this.value.push(tag)
            },
            closeOptions(event) {
                if (event && !event.target.classList.contains('tags-input')) {
                    this.isVisible = false
                }
            },
            goToNextStep() {
                this.venueSoundBidgetData = {
                    venue_tags: this.limitedValue,
                    budget_range: this.averageBudget ?? this.defaultAverage,
                    min: this.minBudget ?? this.defaultMin,
                    max: this.maxBudget ?? this.defaultMax
                }

                this.$emit('next', this.venueSoundBidgetData)
            },
            goToPrevPage() {
                this.$emit('prev')
            },
            handleMinBudget(min) {
                if (!min || !isFinite(min)) min = this.defaultMin
                this.minBudget = min
            },
            handleMaxBudget(max) {
                if (!max || !isFinite(max)) max = this.defaultMax
                this.maxBudget = max
            },
            handleAverageBudget(average) {
                if (!average || !isFinite(average)) average = this.defaultAverage
                this.averageBudget = average
            }
        },
        computed: {
            width() {
                let rangeValue = this.values[1] - this.values[0]
                let procentWidth = (rangeValue * 100) / 450
                return (procentWidth * 515) / 100
            },
            limitedValue() {
                return this.value.slice(0, 5)
            },
            defaultAverage() {
                return (this.defaultMax + this.defaultMin) / 2
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .bg-img {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .event-details {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 50px;
        border-radius: 20px;
    }
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .header {
        height: 24px;
        display: flex;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 21px;
        line-height: 24px;
        letter-spacing: 3px;
        text-transform: uppercase;
        color: #ffffff;
    }
    .header2 {
        width: 571px;
        height: 27px;
        padding: 18px;
        display: flex;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 150%;
        text-align: center;
        letter-spacing: 3px;
        color: #ffffff;
        justify-content: center;
        align-items: flex-start;
    }
    .input-class {
        margin-top: 60px;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .tags-input {
        border: 1px solid #b8b8b8;
        border-radius: 50px;
        width: 717px;
        height: 40px;
        padding-left: 30px;
        background: rgba(22, 22, 22, 0.7);
        color: #ffffff;
        position: relative;
    }
    .tags-input::placeholder {
        text-align: left;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.01em;
        font-feature-settings: 'calt' off;
        color: #ffffff;
    }
    .input-value {
        padding: 20px;
        margin-bottom: 20px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        font-feature-settings: 'calt' off;
        color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .tags {
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.1em;
        color: #ffffff;
        background: rgba(22, 22, 22, 0.7);
        border-radius: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 2px 12px;
        text-transform: capitalize;
        border: 1px solid #fff;
        margin: 2px;
        flex: none;
        order: 0;
        flex-grow: 0;
    }
    .tag-remove {
        display: inline-flex;
        cursor: pointer;
        color: rgb(236, 236, 236);
        margin-left: 4px;
        font-size: 22px;
    }
    .sums {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 21px;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 150%;
        color: #ffffff;
        opacity: 0.6;
    }
    .tags-list {
        display: flex;
        flex-direction: column;
        top: 125px;
        min-width: 100%;
        padding-left: 32px;
        background: rgba(22, 22, 22, 0.9);
        position: absolute;
        z-index: 999;
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 35px;
        letter-spacing: -0.01em;
        font-feature-settings: 'calt' off;
        color: #ffffff;
        cursor: pointer;
    }
    .tags-list p {
        margin-bottom: 0;
    }
    .next-step-budget-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 20px;
        gap: 10px;
        min-width: 467px;
        background: #d7eb5a;
        border-radius: 100px;
        margin-top: 100px;
        border: none;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        font-feature-settings: 'calt' off;
        color: #1b0d29;
    }
    .back-step-budget-btn {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        letter-spacing: 1.25px;
        text-transform: uppercase;
        color: #ffffff;
        margin-top: 18px;
        cursor: pointer;
    }
</style>
